/**
 * Canvas Theme Colors
 *
 * PixiJS can't read CSS variables, so canvas colors are defined here.
 * Phase/signal colors stay unchanged across themes (semantic meaning).
 *
 * Dark palette based on Tailwind Slate (matching SMSuni).
 */

export interface CanvasThemeColors {
  background: number;
  gridLine: number;
  gridMinorAlpha: number;
  gridMajorAlpha: number;
  axisLine: number;
  axisTick: number;
  axisLabel: number;
  axisTitle: number;
  northArrow: number;
  northArrowAlpha: number;
  intLabelDefault: number;
  intLabelSelected: number;
  selectionLine: number;
  phaseBorder: number;
  infoText: number;
}

export const DARK_CANVAS: CanvasThemeColors = {
  background: 0x020817,    // slate-950
  gridLine: 0x94a3b8,      // slate-400
  gridMinorAlpha: 0.12,
  gridMajorAlpha: 0.28,
  axisLine: 0x334155,      // slate-700
  axisTick: 0x475569,      // slate-600
  axisLabel: 0x94a3b8,     // slate-400
  axisTitle: 0x3b82f6,     // blue-500
  northArrow: 0xe2e8f0,    // slate-200
  northArrowAlpha: 0.5,
  intLabelDefault: 0xcbd5e1, // slate-300
  intLabelSelected: 0x3b82f6, // blue-500
  selectionLine: 0x3b82f6,   // blue-500
  phaseBorder: 0xe2e8f0,     // slate-200
  infoText: 0x64748b,        // slate-500
};

export const LIGHT_CANVAS: CanvasThemeColors = {
  background: 0xffffff,
  gridLine: 0x475569,      // slate-600
  gridMinorAlpha: 0.1,
  gridMajorAlpha: 0.25,
  axisLine: 0xcbd5e1,      // slate-300
  axisTick: 0x94a3b8,      // slate-400
  axisLabel: 0x475569,     // slate-600
  axisTitle: 0x2563eb,     // blue-600
  northArrow: 0x334155,    // slate-700
  northArrowAlpha: 0.6,
  intLabelDefault: 0x475569, // slate-600
  intLabelSelected: 0x2563eb, // blue-600
  selectionLine: 0x2563eb,   // blue-600
  phaseBorder: 0x475569,     // slate-600
  infoText: 0x64748b,        // slate-500
};
